import axios from "axios";

// axios.interceptors.request.use((config) => {
//   return config
// }, (err) => {
//   alert('请求超时')
//   return Promise.resolve(err)
// })

// axios.interceptors.response.use((data) => {
//   // 数据统一校验处理
//   return data
// }, (err) => {
//    // 数据异常统一处理
// if (err.response.status === 504 || err.response.status === 404) {
//   alert('服务器被吃了')
// } else if (err.response.status === 403) {
//   alert('权限不足,请联系管理员')
// } else {
//   alert('未知错误')
// }
//   return Promise.resolve(err)
// })

export function postRequest(url, params) {
  return axios({
    method: "POST",
    url: `${url}`,
    headers: {
      "content-type": "application/json",
      // "crossDomain": true,
      //   "xhrFields": {
      //     "withCredentials": true
      //   }
    },
    responseType: "text/plain",
    params: params,
  });
}

export function getRequest1(url, params) {
  return axios({
    headers: {
      "Content-Type": "text/plain",
    },
    method: "POST",
    url: `${url}`,
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    data: params,
  });
  // return axios({
  //   method: 'get',
  //   url: `${url}`,
  //   dataType: "json",
  //   headers: {
  //     "Content-Type": "text/plain"
  //   },
  //   contentType: "application/json; charset=utf-8",
  //   data: params
  // })
}

export function postRequest1(url, params) {
  return axios({
    method: "POST",
    url: `${url}`,
    headers: {
      "content-type": "application/json; charset=utf-8",
      // "content-type": "text/plain"
    },
    dataType: "json",
    data: params,
  });
}

export function postDataRequest(url, params) {
  return axios({
    method: "POST",
    url: `${url}`,
    headers: {
      "content-type": "text/plain",
    },
    //  contentType: "application/json; charset=utf-8",
    responseType: "text/plain",
    data: params,
  });
}

export function postDataRequestja(url, params) {
  return axios({
    method: "POST",
    url: `${url}`,
    headers: {
      token: localStorage.getItem("token"),
      "content-type": "text/plain",
    },
    contentType: "application/json; charset=utf-8",
    // responseType: 'text/plain',
    data: params,
  });
}

export function postDatajRequest(url, params) {
  return axios({
    method: "POST",
    url: `${url}`,
    dataType: "json",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
    //  contentType: "application/json; charset=utf-8",
    //  responseType:'text/plain',
    data: params,
  });
}
export function postDatajNoTokenRequest(url, params) {
  return axios({
    method: "POST",
    url: `${url}`,
    dataType: "json",
    headers: {
      "content-type": "application/json",
    },
    data: params,
  });
}
export function postDatajgold(url, params) {
  return axios({
    method: "POST",
    url: `${url}`,
    dataType: "json",
    headers: {
      "content-type": "text/plain",
    },
    contentType: "application/json; charset=utf-8",
    data: params,
  });
}

export function getRequest(url, params) {
  return axios({
    method: "get",
    url: `${url}`,
    params: params,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "content-type": "application/x-www-form-urlencoded",
    },
    contentType: "application/json; charset=utf-8",
  });
}
export function getRequestNoToken(url, params) {
  return axios({
    method: "get",
    url: `${url}`,
    params: params,
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
    contentType: "application/json; charset=utf-8",
  });
}
// 图片上传
export function uploadFileRequest(url, params) {
  return axios({
    method: "post",
    dataType: "json",
    url: `${url}`,
    data: params,
    cache: false,
    processData: false,
    contentType: false,
    headers: {
      token: localStorage.getItem("token"),
    },
    // headers: {
    //   'Content-Type': 'multipart/form-data'
    // }
  });
}

export function formatDate(num, format = "YY-MM-DD hh:mm:ss") {
  // 转换日期格式
  if (!num) {
    return "";
  }
  const date = new Date(Number(num));
  const map = {
    // Y:date.getFullYear(),//单独处理
    M: date.getMonth() + 1,
    D: date.getDate(),
    h: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
  };

  return format.replace(/([YMDhms])+/g, function (w, t) {
    const v = map[t];

    if (v !== undefined) {
      if (w.length > 1) {
        return ("0" + v).slice(-2);
      }
      return v;
    } else if (t === "Y") {
      return String(date.getFullYear()).slice(-w.length * 2);
    }
    return w;
  });
}

